export enum FirebaseMigrationResource {
    User = 'user',
    Database = 'database',
    Table = 'table',
    Column = 'column',
    Row = 'row',
    Document = 'document',
    Attribute = 'attribute',
    Collection = 'collection',
    Bucket = 'bucket',
    File = 'file',
}
